import { IStateDispatchActions } from '../RouteInfo.context';

interface ISetEventIdAugmentedArgs {
  eventId: string | undefined;
}

export type ISetEventId = (args: ISetEventIdAugmentedArgs) => any;

export const setEventId: IStateDispatchActions<ISetEventId> = (_, dispatch) => args => {
  const { eventId } = args;

  dispatch({ type: 'setEventId', value: eventId });
};
